import { ITpe } from 'src/pages/accueil/model/types';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export const useUpdateTpe = () => {
  const httpClient = useHttpClient(true);

  const updateTpe = async (id: number, data:ITpe) => {
    if (!httpClient.current) throw new Error("HttpClient not ready");

    try {
      const response = await httpClient.current.put(`/api/tpe/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Erreur update TPE :", error);
      throw error;
    }
  };

  return { updateTpe };
};